export default (state = {} , action) => {
    switch (action.type) {
      case "userSession":
        return {
          ...state,
          authenticated: action.payload
        };
      default:
        return state;
    }
  };